import React, { useEffect, useRef } from "react";
import MDIcon from "@mdi/react";
import styled from "@emotion/styled";
import {
  mdiCheckCircle,
  mdiCheck,
  mdiCheckOutline,
  mdiCircle,
  mdiCircleOutline,
  mdiChevronDown,
  mdiChevronUp,
  mdiChevronRight,
  mdiPlus,
  mdiMinus,
  mdiPlusOutline,
  mdiPlusCircle,
  mdiMinusCircle,
  mdiPlusCircleOutline,
  mdiMinusCircleOutline,
  mdiMagnify,
  mdiClose,
  mdiRestore,
  mdiChevronLeftCircleOutline,
  mdiRadioboxBlank,
  mdiRadioboxMarked,
  mdiMenu,
  mdiCart,
  mdiSim,
  mdiViewList,
  mdiCellphone,
  mdiFilterOutline,
  mdiTruckOutline,
  mdiCardAccountDetailsOutline,
  mdiSimOutline,
  mdiCellphoneArrowDown,
  mdiInformation,
  mdiInformationOutline,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiHelpCircle,
  mdiHelpCircleOutline,
  mdiEmoticonHappy,
  mdiEmoticonHappyOutline,
  mdiEmoticonSad,
  mdiEmoticonSadOutline,
  mdiEmoticonExcited,
  mdiEmoticonExcitedOutline,
  mdiEmoticonCool,
  mdiEmoticonCoolOutline,
  mdiDelete,
  mdiPencilOutline,
  mdiArrowRight,
  mdiAccountCircleOutline,
  mdiWalletGiftcard,
  mdiRefresh,
  mdiPhoneOutline,
  mdiFileDocumentOutline,
  mdiFileSearchOutline,
  mdiWalletOutline,
  mdiStorefrontOutline,
  mdiTrashCanOutline,
  mdiPencil,
  mdiCircleMultipleOutline,
  mdiMapMarker
} from "@mdi/js";
import { iconThemes } from "ui-components/theme";
import get from "lodash/get";

import { ReactComponent as ConfirmIdentity } from "assets/icons/icon-confirm-identity.svg";
import { ReactComponent as Delivery } from "assets/icons/icon-delivery.svg";
import { ReactComponent as ListBullet } from "assets/icons/ListBullet.svg";
import { ReactComponent as Asterisk } from "assets/icons/icon-asterisk.svg";
import { getGTMtagdata } from "analytics/utils/helpers";

export const CheckCircle = props =>
  Icon({ gtmdata: {}, ...props, path: mdiCheckCircle });
export const Check = props => Icon({ ...props, path: mdiCheck });
export const CheckOutline = props =>
  Icon({ gtmdata: {}, ...props, path: mdiCheckOutline });
export const Circle = props => Icon({ ...props, path: mdiCircle });
export const CircleOutline = props =>
  Icon({ ...props, path: mdiCircleOutline });
export const Plus = props => Icon({ ...props, path: mdiPlus });
export const Minus = props => Icon({ ...props, path: mdiMinus });
export const PlusOutline = props => Icon({ ...props, path: mdiPlusOutline });
export const PlusCircle = props => Icon({ ...props, path: mdiPlusCircle });
export const MinusCircle = props => Icon({ ...props, path: mdiMinusCircle });
export const PlusCircleOutline = props =>
  Icon({ ...props, path: mdiPlusCircleOutline });
export const MinusCircleOutline = props =>
  Icon({ ...props, path: mdiMinusCircleOutline });
export const ChevronLeftCircleOutline = props => {
  // console.log("  PPPP: ", props);
  return Icon({ path: mdiChevronLeftCircleOutline, ...props });
};

export const ChevronDown = props =>
  Icon({ gtmdata: {}, ...props, path: mdiChevronDown });
export const ChevronUp = props =>
  Icon({ gtmdata: {}, ...props, path: mdiChevronUp });
export const ChevronRight = props => Icon({ ...props, path: mdiChevronRight });
export const Magnify = props => Icon({ ...props, path: mdiMagnify });
export const Close = props =>
  Icon({ gtmdata: {}, color: iconThemes.red, ...props, path: mdiClose });

export const Restore = props => Icon({ ...props, path: mdiRestore });
export const RadioboxBlank = props =>
  Icon({ ...props, path: mdiRadioboxBlank });
export const RadioboxMarked = props =>
  Icon({ ...props, path: mdiRadioboxMarked });
export const Menu = props =>
  Icon({ color: iconThemes.black, ...props, path: mdiMenu });
export const Cart = props => Icon({ ...props, path: mdiCart });
export const Sim = props => Icon({ ...props, path: mdiSim });
export const ViewList = props => Icon({ ...props, path: mdiViewList });
export const Cellphone = props => Icon({ ...props, path: mdiCellphone });
export const FilterOutline = props =>
  Icon({ ...props, path: mdiFilterOutline });
export const TruckOutline = props => Icon({ ...props, path: mdiTruckOutline });
export const CardAccountDetailsOutline = props =>
  Icon({ ...props, path: mdiCardAccountDetailsOutline });
export const SimOutline = props => Icon({ ...props, path: mdiSimOutline });
export const CellphoneArrowDown = props =>
  Icon({ ...props, path: mdiCellphoneArrowDown });
export const Information = props => Icon({ ...props, path: mdiInformation });
export const InformationOutline = props =>
  Icon({ ...props, path: mdiInformationOutline });
export const AlertCircle = props => Icon({ ...props, path: mdiAlertCircle });
export const AlertCircleOutline = props =>
  Icon({ ...props, path: mdiAlertCircleOutline });
export const HelpCircle = props => Icon({ ...props, path: mdiHelpCircle });
export const HelpCircleOutline = props =>
  Icon({ ...props, path: mdiHelpCircleOutline });
export const EmoticonHappy = props =>
  Icon({ ...props, path: mdiEmoticonHappy });
export const EmoticonHappyOutline = props =>
  Icon({ ...props, path: mdiEmoticonHappyOutline });
export const EmoticonSad = props => Icon({ ...props, path: mdiEmoticonSad });
export const EmoticonSadOutline = props =>
  Icon({ ...props, path: mdiEmoticonSadOutline });
export const EmoticonExcited = props =>
  Icon({ ...props, path: mdiEmoticonExcited });
export const EmoticonExcitedOutline = props =>
  Icon({ ...props, path: mdiEmoticonExcitedOutline });
export const EmoticonCool = props => Icon({ ...props, path: mdiEmoticonCool });
export const EmoticonCoolOutline = props =>
  Icon({ ...props, path: mdiEmoticonCoolOutline });
export const ConfirmIdentityIcon = props => <ConfirmIdentity {...props} />;
export const DeliveryIcon = props => <Delivery {...props} />;
export const ListBulletIcon = props => <ListBullet {...props} />;
export const AsteriskIcon = props => <Asterisk {...props} />;

export const DeleteIcon = props => Icon({ ...props, path: mdiDelete });
export const TrashCanOutline = props =>
  Icon({ ...props, path: mdiTrashCanOutline });
export const EditIcon = props => Icon({ ...props, path: mdiPencilOutline });
export const ArrowRight = props => Icon({ ...props, path: mdiArrowRight });
export const UserIcon = props =>
  Icon({ gtmdata: {}, ...props, path: mdiAccountCircleOutline });
export const GiftBox = props => Icon({ ...props, path: mdiWalletGiftcard });
export const RefreshIcon = props => {
  // console.log("refersh ::::",props)
  return Icon({ gtmdata: {}, ...props, path: mdiRefresh });
};
export const PhoneOutline = props => Icon({ ...props, path: mdiPhoneOutline });
export const FileDocumentOutline = props =>
  Icon({ ...props, path: mdiFileDocumentOutline });
export const FileSearchOutline = props =>
  Icon({ ...props, path: mdiFileSearchOutline });
export const WalletOutline = props =>
  Icon({ ...props, path: mdiWalletOutline });
export const StoreOutLine = props =>
  Icon({ ...props, path: mdiStorefrontOutline });
export const EditFilledIcon = props => Icon({ ...props, path: mdiPencil });
export const CircleMultipleOutline = props => Icon({ ...props, path: mdiCircleMultipleOutline });
export const MapMarker = props => Icon({ ...props, path: mdiMapMarker });

const Icon = ({
  path,
  size = "24px",
  theme,
  color,
  style = {},
  gtmdata = {},
  ...props
}) => {
  const iconColor = iconThemes[theme] || color || iconThemes.blue;
  const IconRef = useRef(null);

  useEffect(() => {
    if (IconRef && IconRef.current) {
      if (gtmdata) {
        IconRef.current.childNodes[0].setAttribute(
          "data-gtmdata",
          getGTMtagdata(
            gtmdata["containerName"],
            gtmdata["altContainerName"],
            gtmdata["loggedInUserDetails"],
            gtmdata["altbuttonText"],
            gtmdata["orderRef"],
            gtmdata["locale"]
          )
        );
      }
    }
  }, [IconRef, gtmdata]);
  return (
    <MDIcon
      path={path}
      size={size}
      color={iconColor}
      style={{ ...style }}
      data-testid={get(props, "data-testid", "")}
      data-gtmdata={getGTMtagdata(
        gtmdata["containerName"],
        gtmdata["altContainerName"],
        gtmdata["loggedInUserDetails"],
        gtmdata["altbuttonText"],
        gtmdata["orderRef"],
        gtmdata["locale"]
      )}
      ref={IconRef}
    />
  );
};

const Stacked = styled.div`
  display: inline-flex;
  position: relative;

  > .layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const IconStack = ({ children, size }) => {
  return (
    <Stacked style={{ width: size, height: size }}>
      {React.Children.map(children, child => (
        <div className="layer">{child}</div>
      ))}
    </Stacked>
  );
};
